import { StyleSheet } from 'aphrodite'

import summary from './summary'
import daily from './daily'
import topgeo from './topgeo'
import headers from './headers'
import devider from './devider'
import table from './table'
import paragraphs from './paragraphs'
import navigation from './navigation'
import row from './row'
import graph from './graph'
import transactions from './transactions'
import selector from './selector'
import cpm from './cpm'

import ColorBlind from './ColorBlind'

export default {
  summary: StyleSheet.create(summary),
  headers: StyleSheet.create(headers),
  devider: StyleSheet.create(devider),
  table: StyleSheet.create(table),
  paragraphs: StyleSheet.create(paragraphs),
  daily: StyleSheet.create(daily),
  topgeo: StyleSheet.create(topgeo),
  navigation: StyleSheet.create(navigation),
  row: StyleSheet.create(row),
  graph: StyleSheet.create(graph),
  selector: StyleSheet.create(selector),
  cpm: StyleSheet.create(cpm),
  transactions,
  ColorBlind
}



// WEBPACK FOOTER //
// ./src/components/Statistics/style/index.js